/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDetailShipping_shipment$ref = any;
export type PdpRespShippingReturns_shipment$ref = any;
export type PdpRespShippingReturns_shipment = {
    readonly " $fragmentRefs": PdpSharedDetailShipping_shipment$ref;
    readonly " $refType": PdpRespShippingReturns_shipment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespShippingReturns_shipment",
    "type": "Shipment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedDetailShipping_shipment",
            "args": null
        }
    ]
} as any);
(node as any).hash = '068d48c4fa1782a753ba69b4f347427d';
export default node;
